export const bowelMovement = [
  {
    id: "1",
    image: "https://i.postimg.cc/02QD2zz5/type1.png",
    type: "TYPE 1",
    title:" Separate hard lumps, like nuts (hard to pass); also known as goat faeces",
  },
  {
    id: "2",
    image: "https://i.postimg.cc/Gt3YD2zQ/type2.png",
    type: "TYPE 2",
    title: "Sausage-shaped, but lumpy",
  },
  {
    id: "3",
    image: "https://i.postimg.cc/pTJzy8Qr/type3.png",
    type: "TYPE 3",
    title: "Like a sausage but with cracks on its surface",
  },
  {
    id: "4",
    image: "https://i.postimg.cc/Df51TryY/type4.png",
    type: "TYPE 4",
    title: "Like a sausage or snake, smooth and soft",
  },
  {
    id: "5",
    image: "https://i.postimg.cc/C5v8sgQV/type5.png",
    type: "TYPE 5 ",
    title: "Soft blobs with clear cut edges (passed easily)",
  },
  {
    id: "6",
    image: "https://i.postimg.cc/WbWmMMBJ/type6.png",
    type: "TYPE 6",
    title: "Fluffy pieces with ragged edges, a mushy stool",
  },
  {
    id: "7",
    image: "https://i.postimg.cc/CKDjT9zj/type7.png",
    type: "TYPE 7",
    title: "Watery, no solid pieces, entirely liquid",
  },
  {
    id: "8",
    image: "https://i.postimg.cc/4NNb78Sg/typenone.png",
    type: "NONE",
    title: "No Bowel Movement",
  },
];
